import React, { useState } from "react";

const ReadMore = ({ message_text }) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <>
      <p className="s-chairmen-message-cont-text">
        {isReadMore ? message_text?.slice(0, 615) + "..." : message_text}
      </p>
      <div className="s-chairmen-message-cont-btn">
        {isReadMore ? (
          <span onClick={toggleReadMore} className="eschool-btn secondary-btn">
            Read more <i className="fi fi-rr-plus"></i>
          </span>
        ) : (
          <span onClick={toggleReadMore} className="eschool-btn secondary-btn">
            Show less <i className="fi fi-rr-minus"></i>
          </span>
        )}
      </div>
    </>
  );
};

export default ReadMore;
